import { useEffect } from "react";
import { useRouter } from "next/router";
import * as Sentry from "@sentry/nextjs";

const load = async () => {
  if (!process.env.NEXT_PUBLIC_HT_EVENTS_WRITE_KEY || !process.env.NEXT_PUBLIC_HT_EVENTS_URL) {
    return;
  }

  const { HtEventsBrowser, Destination } = await import("@ht-sdks/events-sdk-js-browser");
  const htevents = new HtEventsBrowser();
  htevents?.load(
    {
      writeKey: process.env.NEXT_PUBLIC_HT_EVENTS_WRITE_KEY,
    },
    {
      apiHost: process.env.NEXT_PUBLIC_HT_EVENTS_URL.replace("https://", ""),
      httpCookieServiceOptions: {
        renewUrl: "/api/ht/renew",
        clearUrl: "/api/ht/clear",
      },
    },
  );

  // Set the htevents object before `registerDestinations` is called so it can be accessed in other scripts
  window.htevents = htevents;

  const registerDestinations = async () => {
    await window.htevents?.register(
      new Destination("Facebook Conversions", "0.0.1", {
        track(ctx) {
          const event = ctx.event;
          const eventName = ctx.event.event;
          const properties = event.properties;
          // Only track Demo Form Submitted and Whitepaper Downloaded to the fb meta pixel
          if (window.fbq && (eventName === "Demo Form Submitted" || eventName === "Whitepaper Downloaded")) {
            // Match meta pixel naming conventions: https://developers.facebook.com/docs/meta-pixel/advanced/advanced-matching
            const traits = {
              em: properties?.Email?.toLocaleString().toLowerCase(),
              fn: properties?.["First Name"]?.toLocaleString().toLowerCase(),
              ln: properties?.["Last Name"]?.toLocaleString().toLowerCase(),
            };
            window.fbq("trackCustom", eventName, traits, { eventID: event.messageId });
          }
        },
      }),
    );
  };

  await registerDestinations();
};

export function HtEvents() {
  const router = useRouter();

  useEffect(() => {
    load().catch((error) => {
      Sentry.captureException(error);
    });
  }, []);

  useEffect(() => {
    const handleRouteChange = () => {
      if (window.htevents) {
        void window.htevents.page();
      }
    };

    handleRouteChange();
    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

  return null;
}
